import * as React from 'react';
import * as school from "./style.module.scss"
export const School = () => {
  return (
    <section className={school.school}>
      <div className="container">
        <h2>Школы, которые используют технологии Advance</h2>
        <p><strong>Уже 98 государственных школ внедрили технологии из курса «Учись Учиться».</strong></p>
        <p>Сейчас в рамках проекта обучаются педагоги и ученики из разных регионов России: Камчатки, Якутии, Санкт-Петербурга, Ленинградской, Тюменской, Калужской, Архангельской и Московской областей.</p>
        <img src="https://fs.advance.ru/landing-pages/about/map.png" alt={""}/>
        <p>Школьники развивают базовые психические функции (память, внимание, воображение, логическое мышление и др.), а педагоги поддерживают их мотивацию. В итоге ученики получают самый важный навык взрослой жизни — умение обучаться. Дети учатся самостоятельно, эффективно и с удовольствием.</p>
        <p><strong>Приглашаем другие регионы создавать новую образовательную среду вместе с нами!</strong></p>
      </div>
    </section>
  );
};
